import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {NetworkStateTypesEnum} from './network-state-types.enum';

@Injectable({
  providedIn: 'root'
})
export class NetworkStateService {
  networkConnectionState$: BehaviorSubject<string | null> = new BehaviorSubject(null);

  checkNetworkState(): void {
    window.ononline = (e) => {
      this.networkConnectionState$.next(e.type);
    };

    window.onoffline = (e) => {
      this.networkConnectionState$.next(e.type);
    };
  }
}
